module.exports = __webpack_public_path__ + "img/myimg_upload.ffe9f89b.svg";